import React from "react";
import { FormattedMessage } from "react-intl";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useLogout from "../../../../../pages/Settings/components/log-out/useLogout.js";

const DropdownMenu = ({ anchorEl, handleClose }) => {
  const open = Boolean(anchorEl);
  const logout = useLogout();

  const handleLogout = () => {
    handleClose();
    logout();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <MenuItem 
      onClick={handleLogout}
      className="ml-2 text-base font-normal leading-5 cursor-pointer text-sky-gray pl-0 tracking-[4.8px] hover:text-light-purple font-sans no-bg-hover"
      style={{ backgroundColor: 'transparent' }}
      >
        <FormattedMessage id="teamroom.header.logOut" />
      </MenuItem>
    </Menu>
  );
};

export default DropdownMenu;